import React from 'react';
import Container from "../../components/container/container-component";
import "./reports.css";
import Report from "../../components/report/report-component";
import Spinner from "../../components/spinner/spinner-component";



const ReportsComponent = (
  {
    reports,
    loading
  }
) => {
  return (
    <Container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <div className="reports shadow">
        <h2 style={{padding: '10px'}}>Reports</h2>
        {
          loading ?
            <Spinner
              loading={loading}
              marginTop="100px"
            />
            :
            reports.map((report, i) => <Report key={i} {...report} />)
        }
      </div>
    </Container>
  )
};


export default ReportsComponent;


// WEBPACK FOOTER //
// ./src/modules/reports/reports-component.js